/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


export default {
  ADD_ITEM (state, user) {
    state.users.push(Object.assign({}, user))
  },
  SET_USERS (state, user) {
    state.users = user
  },
  SET_GB_DATA(state,user){
    state.gbdata = user
  },
  REMOVE_RECORD (state, itemId) {
    const userIndex = state.users.findIndex((u) => u.id === itemId)
    state.users.splice(userIndex, 1)
  }
}
